var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 733,
    viewBox: "0 0 813 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 75,
    width: 620,
    height: 608,
    rx: 103,
    fill: "#1491FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.842 491.605C415.842 454.237 436.395 420.605 466.289 403.789C442 394.447 412.105 388.842 378.474 388.842C296.263 388.842 229 422.474 229 463.579V500.947H415.842V491.605ZM518.605 426.211C483.105 426.211 453.211 456.105 453.211 491.605C453.211 527.105 483.105 557 518.605 557C554.105 557 584 527.105 584 491.605C584 456.105 554.105 426.211 518.605 426.211ZM453.211 276.737C453.211 317.842 419.579 351.474 378.474 351.474C337.368 351.474 303.737 317.842 303.737 276.737C303.737 235.632 337.368 202 378.474 202C419.579 202 453.211 235.632 453.211 276.737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.1754237a9b107cd21e23a89ba3d24cc5.svg";
export { ForwardRef as ReactComponent };